import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { SelectingType } from "./zonesSlice";

export type Type = "bus" | "people";

interface IState {
  trafficAnalysisStarUrl: string[];
  dataForPost: any;
}

const initialState: IState = {
  trafficAnalysisStarUrl: [],
  dataForPost: {},
};

export const starSlice = createSlice({
  name: "star",
  initialState,
  reducers: {
    createTrafficAnalysisStarUrl: (state, action: PayloadAction<string[]>) => {
      return { ...state, trafficAnalysisStarUrl: action.payload };
    },
    changeDataForPost: (state, action: PayloadAction<any>) => {
      return { ...state, dataForPost: action.payload };
    },
  },
});

export const { createTrafficAnalysisStarUrl, changeDataForPost } = starSlice.actions;

export default starSlice.reducer;
